var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlame = function SvgFlame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.776 4.099a.839.839 0 0 0-1.14 1.125 6.84 6.84 0 0 1 .025 6.17.167.167 0 0 1-.293-.004 3.745 3.745 0 0 1-.375-1.051.505.505 0 0 0-.808-.293 5.803 5.803 0 0 0-1.865 6.438 5.236 5.236 0 0 0 5.197 3.51c2.836 0 4.82-1.439 5.443-3.945.924-3.7-1.345-9.386-6.184-11.95zm3.177 11.99a2.223 2.223 0 0 1-2.353 1.896A2.284 2.284 0 0 1 9.35 16.1a.336.336 0 0 1 .407-.385 2.016 2.016 0 0 0 1.677-.946 1.542 1.542 0 0 0 .304-1.65.335.335 0 0 1 .41-.478 3.168 3.168 0 0 1 1.805 3.447z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "flame.17b6ee58a806eebcae0fada3381302a4.svg";